/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaCabinet: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="cabinet" viewBox="0 0 15 15">
      <path
        d="M4.99998 7.8125C4.99998 7.46732 5.2798 7.1875 5.62498 7.1875C5.97016 7.1875 6.24998 7.46732 6.24998 7.8125V9.0625C6.24998 9.40768 5.97016 9.6875 5.62498 9.6875C5.2798 9.6875 4.99998 9.40768 4.99998 9.0625V7.8125Z"
        fill="#2C3439"
      ></path>
      <path
        d="M9.42339 7.8125C9.42339 7.46732 9.70321 7.1875 10.0484 7.1875C10.3936 7.1875 10.6734 7.46732 10.6734 7.8125V9.0625C10.6734 9.40768 10.3936 9.6875 10.0484 9.6875C9.70321 9.6875 9.42339 9.40768 9.42339 9.0625V7.8125Z"
        fill="#2C3439"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.9375 2.5C0.9375 3.25592 1.4743 3.88647 2.1875 4.03124V11.875C2.1875 12.9105 3.02697 13.75 4.0625 13.75H11.5625C12.598 13.75 13.4375 12.9105 13.4375 11.875V4.03124C14.1507 3.88647 14.6875 3.25592 14.6875 2.5C14.6875 1.63705 13.9879 0.9375 13.125 0.9375H2.5C1.63706 0.9375 0.9375 1.63706 0.9375 2.5ZM2.5 2.1875C2.32741 2.1875 2.1875 2.32741 2.1875 2.5C2.1875 2.67259 2.32741 2.8125 2.5 2.8125H13.125C13.2976 2.8125 13.4375 2.67259 13.4375 2.5C13.4375 2.32741 13.2976 2.1875 13.125 2.1875H2.5ZM3.4375 11.875V4.0625H7.1875V12.5H4.0625C3.71732 12.5 3.4375 12.2202 3.4375 11.875ZM8.4375 12.5V4.0625H12.1875V11.875C12.1875 12.2202 11.9077 12.5 11.5625 12.5H8.4375Z"
        fill="#2C3439"
      ></path>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaCabinet)
